/*
 * $Id:: SSOHelpers.js 2021/02/24 05:35 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { getLoginUrl, getLogoutUrl } from '../../providers';

const triggerAuth = () => {
    const loginUrl = getLoginUrl();
    window.location.replace(loginUrl);
};

const verifyLoginToSSO = (redirectUrl) => {
    window.location.replace(redirectUrl);
};

const logout = () => {
    const logoutUrl = getLogoutUrl();
    window.location.replace(logoutUrl);
};

export default {
    logout,
    verifyLoginToSSO,
    triggerAuth,
};
